import { cn } from '@/lib/utils';
import { ChevronUp } from 'lucide-react';
import {useEffect, useState} from 'react';

const BackToTop = () => {
  const [displayed, setDisplayed] = useState(false);

  useEffect(() => {
    const scrollListener = () => {
      const scrolled = document.documentElement.scrollTop;
      const pageHeight = window.innerHeight;

      if (scrolled >= pageHeight / 2) {
        setDisplayed(true);
      } else {
        setDisplayed(false);
      }
    };

    window.addEventListener('scroll', scrollListener);

    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={cn(
        "cursor-pointer fixed z-40 bottom-4 right-4 h-12 w-12 flex justify-center items-center rounded-full bg-red-500/20 border-2 border-red-500 duration-300",
        {
          'opacity-0 pointer-events-none': !displayed,
          'opacity-100': displayed,
        }
      )}
    >
      <ChevronUp className='text-xl text-red-500' />
    </button>
  );
};

export default BackToTop;
